import React from "react";

function BlogDetails() {
  return <div>BlogDetails</div>;
}

export default BlogDetails;
